import { getImageSrc } from "./getImageSrc";

export function getSearchResultData(result: any): any[] {
  if (!result) return [];
  if (Array.isArray(result)) return result;
  if (Array.isArray(result.data)) return result.data;
  if (Array.isArray(result.items)) return result.items;
  if (Array.isArray(result.results)) return result.results;
  return [];
}

function pickText(...values: any[]): string {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) {
      return value;
    }

    if (Array.isArray(value)) {
      const nested = pickText(...value);
      if (nested) return nested;
    }

    if (value && typeof value === "object") {
      const nested = pickText(
        value.name,
        value.title,
        value.subtitle,
        value.under_title,
        value.meta_text,
        value.description,
        value.content,
        value.text,
        value.value,
        value.label,
      );

      if (nested) return nested;
    }
  }

  return "";
}

function normalizeArray(value: any) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
}

function normalizeCategory(category: any) {
  if (!category) return null;

  return {
    ...category,
    id: category.id ?? category.category_id ?? category.value ?? 0,
    name: category.name ?? category.title ?? category.label ?? "",
    logo: getImageSrc(category.logo, category.image, category.cover),
  };
}

function normalizeProject(project: any, fallbackCategory: any[]) {
  if (!project) return [];

  const projectCategories = [
    ...normalizeArray(project.categories),
    ...normalizeArray(project.category),
  ]
    .map(normalizeCategory)
    .filter(Boolean);

  return [
    {
      ...project,
      id: project.id ?? project.project_id ?? 0,
      name: project.name ?? project.title ?? "",
      logo: getImageSrc(
        project.logo,
        project.cover,
        project.image,
        project.avatar,
      ),
      categories:
        projectCategories.length > 0 ? projectCategories : fallbackCategory,
    },
  ];
}

export function normalizeSearchNewsItems(items: any[] = []) {
  return items.map((item) => {
    const dyna = item?.dyna ?? {};
    const title = pickText(
      item.name,
      item.title,
      item.headline,
      item.label,
      item.meta_text,
      dyna.name,
      dyna.title,
      item.extra,
      item.dyna,
    );
    // const subtitle = pickText(
    //   item.subtitle,
    //   item.under_title,
    //   dyna.under_title,
    //   item.description,
    //   item.summary,
    //   item.content,
    //   dyna.content,
    //   item.extra,
    //   item.meta_text,
    // );
    const imageUrl = getImageSrc(
      dyna.cover,
      item.images,
      item.image,
      dyna.image,
      item.cover,
      item.logo,
      item.extra,
    );
    const projectSource =
      item.projects ?? item.project ?? dyna.projects ?? dyna.project;
    const normalizedCategories = [
      ...normalizeArray(item.categories),
      ...normalizeArray(dyna.categories),
      ...normalizeArray(dyna.projects?.category),
      ...normalizeArray(dyna.project?.category),
    ]
      .map(normalizeCategory)
      .filter(Boolean);

    return {
      ...item,
      id: item.id,
      name: title,

      subtitle: item.under_title ?? dyna.under_title ?? "",

      release_date:
        item.release_date ??
        item.date_release ??
        dyna.date_release ??
        item.created_at,

      images:
        Array.isArray(item.images) && item.images.length > 0
          ? item.images
          : imageUrl
            ? [
                {
                  id: item.id ?? 0,
                  url: imageUrl,
                  caption: null,
                  type: "image",
                },
              ]
            : [],

      projects: Array.isArray(projectSource)
        ? projectSource.flatMap((p) =>
            normalizeProject(p, normalizedCategories),
          )
        : projectSource
          ? normalizeProject(projectSource, normalizedCategories)
          : [],

      categories: normalizedCategories,
    };
  });
}
